export default __webpack_public_path__ + "static/media/NEE.eb77d080.png";